import { HStack, VStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { genNameInitials } from "@/utils/name";

import type { SelectedPersonOption } from "../../-types";

const InviteComboboxSelectedPersonOption = ({
  person,
}: {
  person: SelectedPersonOption;
}) => (
  <HStack className="items-center gap-3">
    <Avatar className="size-9">
      <AvatarImage src={person.avatarUrl} alt={person.label} />
      <AvatarFallback>
        <Text variant="labelSmall">{genNameInitials(person.label)}</Text>
      </AvatarFallback>
    </Avatar>
    <VStack>
      <Text variant="label">{person.label}</Text>
      <Text variant="labelSmall" className="text-muted-foreground">
        {person.email}
      </Text>
    </VStack>
  </HStack>
);

export default InviteComboboxSelectedPersonOption;
